import {RootState} from 'common/src/redux/store';

function isCampaignPageNavigationCompleted(getState: () => RootState): boolean {
  const state = getState();
  const {campaignWorkflowDataByStep} = state.campaignPage;

  return !!campaignWorkflowDataByStep;
}

export default isCampaignPageNavigationCompleted;
